import { render, staticRenderFns } from "./ShowDivider.vue?vue&type=template&id=225db8cb"
import script from "./ShowDivider.vue?vue&type=script&lang=js"
export * from "./ShowDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports